<template>
  <div>
    <h1>Impossible de charger la page.</h1>
  </div>
</template>